import { convertObjToQueryString } from "../../utils/helpers";

export const saveMealPlan = (
  data: {
    [key: string]: any;
  },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_NUTRITION_URL}/v1/mealPlan/save`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const saveMealPlanPanel = (data: { [key: string]: any }) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_NUTRITION_URL}/v1/panel/mealPlan/save`,
    data,
  };
};

export const getMealPlanStartDate = (queryObj: { [key: string]: any }) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_NUTRITION_URL}/v1/mealPlan/startDate${query}`,
  };
};

export const generateMealPlanPDF = (
  data: {
    [key: string]: any;
  },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_NUTRITION_URL}/v1/generateMealPlanPDF`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getUserMealPlan = (
  data: {
    [key: string]: any;
  },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_NUTRITION_URL}/v1/panel/getMealPlan`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};
